export default "__VITE_ASSET__6e07de4f__"